import port from "../assets/port.png";
import js from "../assets/js.svg";
import rt from "../assets/react.png";
import py from "../assets/py.png";
import nt from "../assets/nxt.png";
import dj from "../assets/dj.png";
import dk from "../assets/dk.png";
import gh from "../assets/gh.webp";
import git from "../assets/git.png";
import ng from "../assets/ng.png";
import psql from "../assets/psql.png";
import ts from "../assets/ts.svg";
import rest from "../assets/rest.png";
import tw from "../assets/tw.png";
import html from "../assets/html.png";
import css from "../assets/css.png";
import aws from "../assets/aws.png";
import sland from "../assets/sland.png";
import logdash from "../assets/logdash.png";
import bills from "../assets/bills.png";
import health from "../assets/health.png";
import ecomadmin from "../assets/ecomadmin.png";

const features = [
  {
    name: "SaaS Landing",
    image: `${sland}`,
    skills: ["React", "Node.js", "Express", "MongoDB"],
    href: "/",
  },
  {
    name: "Job Tracker",
    image: `${port}`,
    skills: ["React", "Node.js", "Express", "MongoDB"],
    href: "/",
  },
  {
    name: "Client Website",
    image: `${port}`,
    skills: ["React", "Node.js", "Express", "MongoDB"],
    href: "/",
  },
  {
    name: "Snack Attack",
    image: `${port}`,
    skills: ["React", "Node.js", "Express", "MongoDB"],
    href: "/",
  },
  {
    name: "Traveling Postman",
    image: `${logdash}`,
    skills: ["React", "Node.js", "Express", "MongoDB"],
    href: "/",
  },
  {
    name: "Portfolio",
    image: `${port}`,
    skills: ["React", "Node.js", "Express", "MongoDB"],
    href: "/",
  },
];

export default function Projects() {
  return (
    <div id="projects">
      <div className="max-w-7xl mx-auto py-20 px-4 text-center sm:px-6 lg:px-8  ">
        <div className="space-y-8 sm:space-y-12 ">
          <div className="space-y-5 sm:mx-auto sm:max-w-xl sm:space-y-4 lg:max-w-5xl">
            {" "}
            <h2 className="text-3xl font-semibold text-primary tracking-widest sm:text-6xl font-oleo uppercase">
              Recent Projects
            </h2>
            <p className="text-xl text-neutral">
              These projects contain both personal projects and projects
              constructed for clients. I am capable of creating backend,
              frontend, or fullstack applications.
            </p>
          </div>
          <section className="mx-auto bg-base-300">
            <div className="grid items-center grid-cols-1 mb-12 md:grid-cols-2 gap-y-10 md:gap-y-32 gap-x-10 md:gap-x-24 p-10">
              <div>
                <h2 className="mb-4 text-2xl font-extrabold tracking-tight text-center text-secondary md:leading-tight sm:text-left md:text-4xl">
                  SaaS Landing
                </h2>
                <div className="flex mb-4 gap-2">
                  <img
                    alt=""
                    src={js}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={rt}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={tw}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={html}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={css}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                </div>
                <p className="mb-5 text-base text-center text-primary sm:text-left md:text-lg">
                  SaaS landing is a standalone web page, created specifically
                  for a marketing or advertising campaign. It’s focus that makes
                  landing pages the best option for increasing the conversion
                  rates of your marketing campaigns and lowering your cost of
                  acquiring a lead or sale.
                </p>
                <div className="flex flex-col sm:flex-row justify-start gap-4">
                  <button
                    onClick={() => {
                      window.open("https://dtslab-saaslanding.vercel.app/");
                    }}
                    className="btn  hover:bg-white hover:text-neutral-content text-white  w-36 text-xl bg-neutral-content"
                  >
                    View Site
                  </button>

                  <button
                    onClick={() => {
                      window.open("https://github.com/dtslab/saas-landing");
                    }}
                    className="btn  hover:bg-white hover:text-neutral-content text-white  w-54 text-xl bg-neutral-content"
                  >
                    View GitHub Repo
                  </button>
                </div>
              </div>
              <div className="mockup-window border bg-base-100">
                <img
                  alt=""
                  src={sland}
                  className="flex justify-center border-t"
                />
              </div>
            </div>
            <div className="grid flex-col-reverse items-center grid-cols-1 md:grid-cols-2 gap-y-10 md:gap-y-32 gap-x-10 md:gap-x-24 mb-12 p-10">
              <div className="order-none md:order-2 ">
                <h2 className="mb-4 text-2xl font-extrabold tracking-tight text-center text-secondary md:leading-tight sm:text-left md:text-4xl">
                  Ecommerce Dashboard
                </h2>{" "}
                <div className="flex mb-4 gap-2">
                  <img
                    alt=""
                    src={js}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={rt}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={tw}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={html}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={css}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                </div>
                <p className="mb-5 text-base text-center text-primary sm:text-left md:text-lg">
                  An ecommerce dashboard allows for the monitoring and reporting
                  on important ecommerce KPIs concerning orders, employees, and
                  customers. It is a modern analytics tool with apps and charts
                  that helps to visualize and optimize ecommerce operations
                  through advanced data analyses.
                </p>
                <div className="flex flex-col sm:flex-row justify-start gap-4 mx-auto">
                  <button
                    onClick={() => {
                      window.open("https://dtslab-ecomadmin.vercel.app/");
                    }}
                    className="btn  hover:bg-white hover:text-neutral-content text-white  w-36 text-xl bg-neutral-content"
                  >
                    View Site
                  </button>

                  <button
                    onClick={() => {
                      window.open("https://github.com/dtslab/admin-dashboard");
                    }}
                    className="btn  hover:bg-white hover:text-neutral-content text-white  w-54 text-xl bg-neutral-content"
                  >
                    View GitHub Repo
                  </button>
                </div>
              </div>
              <div className="mockup-window border bg-base-100">
                <img
                  alt=""
                  src={ecomadmin}
                  className="flex justify-center border-t"
                />
              </div>{" "}
            </div>
            <div className="grid items-center grid-cols-1 mb-12 md:grid-cols-2 gap-y-10 md:gap-y-32 gap-x-10 md:gap-x-24 p-10">
              <div>
                <h2 className="mb-4 text-2xl font-extrabold tracking-tight text-center text-secondary md:leading-tight sm:text-left md:text-4xl">
                  Billing App
                </h2>
                <div className="flex mb-4 gap-2">
                  <img
                    alt=""
                    src={js}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={rt}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={tw}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={html}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={css}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                </div>
                <p className="mb-5 text-base text-center text-primary sm:text-left md:text-lg">
                  Handle your expense monthly transactions efficiently with the
                  clear overview in Dashboard. Features like the smart search
                  option allow you to quickly find any data you’re looking for.
                </p>
                <div className="flex flex-col sm:flex-row justify-start gap-4">
                  <button
                    onClick={() => {
                      window.open("https://dtslab-billing.vercel.app/");
                    }}
                    className="btn  hover:bg-white hover:text-neutral-content text-white  w-36 text-xl bg-neutral-content"
                  >
                    View Site
                  </button>

                  <button
                    onClick={() => {
                      window.open("https://github.com/dtslab/billing-app");
                    }}
                    className="btn  hover:bg-white hover:text-neutral-content text-white  w-54 text-xl bg-neutral-content"
                  >
                    View GitHub Repo
                  </button>
                </div>
              </div>
              <div className="mockup-window border bg-base-100">
                <img
                  alt=""
                  src={bills}
                  className="flex justify-center border-t"
                />
              </div>{" "}
            </div>
            <div className="grid flex-col-reverse items-center grid-cols-1 md:grid-cols-2 gap-y-10 md:gap-y-32 gap-x-10 md:gap-x-24 p-10">
              <div className="order-none md:order-2">
                <h2 className="mb-4 text-2xl font-extrabold tracking-tight text-center text-secondary md:leading-tight sm:text-left md:text-4xl">
                  Health Monitor
                </h2>{" "}
                <div className="flex mb-4 gap-2">
                  <img
                    alt=""
                    src={js}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={rt}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={tw}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={html}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                  <img
                    alt=""
                    src={css}
                    className="bg-base-100 h-7 w-7 rounded-full"
                  />
                </div>
                <p className="mb-5 text-base text-center text-primary sm:text-left md:text-lg">
                  Health monitor Stream to view and analyze your health and
                  fitness data. Seamlessly move your health and fitness data
                  between apps, trackers, and devices so that you can gain
                  insight into your data in different ways. See your stats over
                  time, gain insight, and stay motivated.
                </p>
                <div className="flex flex-col sm:flex-row justify-start gap-4">
                  <button
                    onClick={() => {
                      window.open(
                        "https://dtslab-health.vercel.app/health-track/"
                      );
                    }}
                    className="btn  hover:bg-white hover:text-neutral-content text-white  w-36 text-xl bg-neutral-content"
                  >
                    View Site
                  </button>

                  <button
                    onClick={() => {
                      window.open("https://github.com/dtslab/health-monitor");
                    }}
                    className="btn  hover:bg-white hover:text-neutral-content text-white  w-54 text-xl bg-neutral-content"
                  >
                    View GitHub Repo
                  </button>
                </div>
              </div>
              <div className="mockup-window border bg-base-100">
                <img
                  alt=""
                  src={health}
                  className="flex justify-center border-t"
                />
              </div>{" "}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
